"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TooltipIcon = exports.Tooltip = exports.TooltipPositions = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = __importStar(require("react"));
var TooltipPositions;
(function (TooltipPositions) {
    TooltipPositions["TOP"] = "top";
    TooltipPositions["LEFT"] = "left";
    TooltipPositions["BOTTOM"] = "bottom";
    TooltipPositions["RIGHT"] = "right";
    TooltipPositions["TOP_RIGHT"] = "top-right";
    TooltipPositions["BOTTOM_RIGHT"] = "bottom-right";
    TooltipPositions["BOTTOM_LEFT"] = "bottom-left";
    TooltipPositions["TOP_LEFT"] = "top-left";
})(TooltipPositions = exports.TooltipPositions || (exports.TooltipPositions = {}));
var Tooltip = function (props) {
    var _a = React.useState(false), isVisible = _a[0], setVisible = _a[1];
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "tooltip trigger-on-".concat(props.triggeredOn || "hover", " ").concat(props.className || "", " ").concat(props.position || "top", "-side ").concat(props.hasArrow ? "has-arrow" : ""), "data-visible": isVisible, style: props.style || undefined, tabIndex: 0, onBlur: function () {
            return setTimeout(function () { return setVisible(false); }, 300);
        } /** TODO: consider finding an alternative for setTimeout */, "data-testid": props.testId }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "tooltip__element", onClick: function () {
                    setVisible(!isVisible);
                } }, { children: props.shownElement })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "tooltip__content", onClick: function () {
                    setVisible(!isVisible);
                } }, { children: props.children }))] })));
};
exports.Tooltip = Tooltip;
var TooltipIcon = function (props) {
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "tooltip-icon ".concat(props.className || "") }, { children: (0, jsx_runtime_1.jsx)("h6", __assign({ className: "tooltip-icon__text mb-0 text-lowercase d-flex align-items-center" }, { children: "i" })) })));
};
exports.TooltipIcon = TooltipIcon;
